<template>
    <div class="statistics">
        <el-row>
            <el-col v-for="(statistic, index) in importStatistics" :span="8" :xl="4"
                v-bind:class="[ 'statistic', statistic.color || 'primary' ]" :key="index">

                <el-row style="padding: 5px 25px 5px 10px;">
                    <el-col :span="18">
                        <p class="statCount">{{ statistic.value }}</p>
                        <span class="stat-text">{{ statistic.label }} </span>
                    </el-col>
                    <el-col :span="6" type="flex" align="end">
                        <!-- <div class="flex-wrapper">
                            <div class="single-chart">
                                <svg viewBox="0 0 36 36" class="circular-chart orange">
                                    <path class="circle-bg"
                                          d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <path class="circle"
                                          :stroke-dasharray="statistic.percent + ', 100'"
                                          d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <text v-if="statistic.percent > 0" x="18" y="20.35" class="percentage">
                                        {{ Math.round(statistic.percent) }}%
                                    </text>
                                </svg>
                            </div>
                        </div> -->
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import ImportMixin from './mixin'

const STATISTICS = [
    [
        {
            label: 'not resolved',
            color: 'red',
            compute: (patients) => patients.filter((patient) => (patient.invalid && !patient.skip && !patient.corrected)).length
        },
        {
            label: 'new patients',
            compute: (patients) => patients.filter((patient) => ! patient.existing).length
        },
        {
            label: 'existing patients',
            compute: (patients) => patients.filter((patient) => patient.existing).length
        }
    ],
    [
    	{
    		label: 'not resolved',
            color: 'red',
    		compute: (patients) => patients.map((patient) => (!patient.invalid && patient.confirmed === false)).length
    	},
        {
            label: 'new events scheduled',
            compute: (patients) => patients.map((patient) => (
                (patient.data && !patient.invalid &&
                (patient.confirmed == null || patient.confirmed === true) &&
                Array.isArray(patient.data.event)) ? patient.data.event.length : 0)).reduce((a, b) => a + b, 0)
        },
    	{
    		label: 'events rescheduled',
    		compute: (patients) => patients.map((patient) => patient.rescheduled).length
    	}
    ]
]

export default {
    name: 'import-patient-statistics',
    mixins: [ ImportMixin ],

    data() {
        return {
            statistics: STATISTICS
        }
    },

    computed: {
        importStatistics() {
            return this.statistics[this.step].map((statistic) => ({
                label: statistic.label,
                color: statistic.color,
                value: statistic.compute(this.patient || [])
            }))
            .map((statistic) => {
                if (this.patient.length > 0)
                    statistic.percent = 100.0 * statistic.value / this.patient.length
                return statistic
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.statistics {
    background: lighten($primary-color, 60%);
    padding: 10px 5px 0px 15px;
}
.statistic {
    background: white;
    padding: 15px;
    height: 130px;
    border-right: solid 10px lighten($primary-color, 60%);
}

.statCount {
    font-size: 70px;
    font-weight: 300;
    color: $primary-color;
}
.statistic.red .statCount {
    color: #da4e4e;
}
.statCircle {
    position: relative;
    height: 60px;
    width: 60px;
    border-radius: 100px;
    border: 4px solid $primary-color;
}
.statistic.red .statCircle {
    border-color: #da4e4e;
}
.percentage {
    position: absolute;
    top: 18px;
    left: 12px;
    color: #7f7f7f;
}
.stat-text{
    font-size: 16px;
    color: #333;
}


.flex-wrapper {
    display: flex;
    flex-flow: row nowrap;
}

.single-chart {
    height: 120px;
    width: 100%;
    justify-content: space-around ;
}

.circular-chart {
    display: block;
    margin: 0px auto;
    height: 60%;
}

.circle-bg {
    fill: none;
    stroke: #eee;
    stroke-width: 3.8;
}

.circle {
    fill: none;
    stroke-width: 2.8;
    stroke-linecap: round;
    animation: progress 1s ease-out forwards;
}

@keyframes progress {
    0% {
        stroke-dasharray: 0 100;
    }
}

.circular-chart.orange .circle {
    stroke: $primary-color;
}
.percentage {
    fill: #333;
    font-size: 0.5em;
    text-anchor: middle;
}
</style>
